module.exports = __webpack_public_path__ + "static/vinos_poligono-13-bd1505833bb644fc040aace39742aea6.jpg";